import React, { useState, useEffect } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import { ClipLoader } from "react-spinners";

const BookConsultation: React.FC = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const head: any = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    head.appendChild(script);
  }, []);

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  };
  useEffect(() => {
    loadings();
  }, []);

  return (
    <div>
      {ready ? (
        <>
          <Header />
          <div className="container" style={{ marginTop: "40px" }}>
            <div className="row">
              <div className="col-md-4">
                <h3 style={{ paddingTop: "100px", fontWeight: "bold" }}>
                  I need more information?
                </h3>
                <h5 style={{ paddingTop: "10px", marginBottom: "10px" }}>
                  Book a Free Consultation with Us Now!
                </h5>
                <img
                  src="../../images/meetingss.png"
                  alt="Emeeting"
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-md-8">
                <div id="schedule_form">
                  <div
                    className="calendly-inline-widget"
                    // data-url="https://calendly.com/calebmide?primary_color=67b375"
                    data-url="https://calendly.com/doyenifyacademy?primary_color=67b375"
                    style={{ minWidth: "100%", height: "900px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BookConsultation;
